import { Button, Input, Row, Space } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Alert } from "rsuite";
import logo from "../../assets/images/satisfi_black.svg";
import constants from "../../constants";
import services from "../../services";
import { passwordValidate } from "../../services/Validate";

const api = services.api;
const invalidPwd = "Use 8-30 characters with a mix of upper & lower case letters, numbers & symbols";

class ResetPassword extends Component {
    constructor(props) {
        super(props);

        this.state = {
            newPassword: "",
            confirmPassword: "",
            isValidNewPassword: true,
        };
    }

    setNewPassword = (e) => {
        this.setState({ newPassword: e.target.value, isValidNewPassword: passwordValidate(e.target.value) });
    };

    setConfirmPassword = (e) => {
        this.setState({ confirmPassword: e.target.value });
    };

    onSubmit = async () => {
        let window_url = new URL(window.location);
        let searchString = window_url.search;
        let splitUrl = searchString.split("=");
        if (this.state.newPassword.length > 0 && this.state.confirmPassword.length > 0 && this.state.isValidNewPassword) {
            if (this.state.newPassword != this.state.confirmPassword) {
                Alert.error("Passwords are not matching");
            } else {
                let reqObj = {
                    code: splitUrl[1],
                    password: this.state.newPassword,
                    passwordConfirmation: this.state.confirmPassword,
                };
                try {
                    const upload_config = {
                        method: "post",
                        url: constants.resetPassword,
                        headers: {
                            "Content-Type": "application/json",
                        },
                        data: reqObj,
                    };

                    let resetPassword = await axios(upload_config);
                    // return resetPassword
                    if (resetPassword) {
                        Alert.success("Password Succefully Updated.");
                        this.props.parent.history.push("/signin");
                    } else {
                        Alert.error("Something went wrong, Please check the Password/Link");
                    }
                } catch (error) {
                    Alert.error(error.response.data.message[0].messages[0].message || "Something went wrong");
                }
            }
        } else {
            Alert.error("Enter valid password");
        }
    };

    render() {
        const hide = {
            display: "none",
        };

        const show = {
            display: "block",
        };

        return (
            <section className="login" style={{ justifyContent: "center", minWidth: "548px" }}>
                {/* <div className="col-md-6 col-sm-6 col-xs-12 login-left-container">
                    <Login image={login1} header="Hey! Reset Your Password" loginType="resetpassword" imgStyle={{
                        width: "400px"
                    }} />
                </div> */}

                <Row justify={"center"} align={"middle"}>
                    <div className=" emailstyle forgot-reset-container" style={{ maxWidth: "548px" }}>
                        {/* <h4>Reset your password</h4> */}

                        <div className="login-inner-container">
                            <img src={logo} height={"40px"} className="mb-4" />
                            <p className="forget">Enter your new password</p>
                            <Space size={"large"} direction={"vertical"}>
                                <Input
                                    // containerClass="col-md-12 col-sm-12 col-xs-12 pl-0"
                                    type="password"
                                    name="password"
                                    placeholder="New password"
                                    value={this.state.newPassword}
                                    onChange={this.setNewPassword}
                                    className="forgotInput"
                                    style={{ width: "548px" }}
                                />
                                <Input
                                    // containerClass="col-md-12 col-sm-12 col-xs-12 pl-0"
                                    type="password"
                                    name="password"
                                    placeholder="Confirm password"
                                    value={this.state.confirmPassword}
                                    onChange={this.setConfirmPassword}
                                    className="forgotInput"
                                    style={{ width: "548px" }}
                                />
                                <div>
                                    <Button onClick={this.onSubmit} className="forgotButton">
                                        Submit
                                    </Button>
                                    <span className="error-msg" style={this.state.isValidNewPassword ? hide : show}>
                                        {invalidPwd}
                                    </span>
                                </div>
                            </Space>
                        </div>
                    </div>
                </Row>
            </section>
        );
    }
}

export default withRouter(ResetPassword);
